import { ChevronDown, ChevronUp } from 'lucide-react';
import React from 'react';

export const getSortIcon = (isSorted: false | 'asc' | 'desc') => {
  if (isSorted === 'asc') {
    return <ChevronUp className="h-4 w-4 text-text-muted" />;
  }
  if (isSorted === 'desc') {
    return <ChevronDown className="h-4 w-4 text-text-muted" />;
  }
  return <ChevronUp className="h-4 w-4 text-text-muted" />;
};
